
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.99 2C6.468 2.006 1.996 6.485 2 12.007c.004 5.521 4.482 9.995 10.003 9.993C17.525 21.998 22 17.522 22 12A10 10 0 0011.99 2zm6.93 6h-2.95a15.649 15.649 0 00-1.38-3.56A8.03 8.03 0 0118.92 8zM12 4.04A14.087 14.087 0 0113.91 8h-3.82A14.087 14.087 0 0112 4.04zM4.26 14a7.822 7.822 0 010-4h3.38a16.515 16.515 0 00-.14 2c.006.669.053 1.337.14 2H4.26zm.82 2h2.95a15.649 15.649 0 001.38 3.56A7.987 7.987 0 015.08 16zm2.95-8H5.08a7.987 7.987 0 014.33-3.56A15.649 15.649 0 008.03 8zM12 19.96A14.087 14.087 0 0110.09 16h3.82A14.087 14.087 0 0112 19.96zM14.34 14H9.66a14.713 14.713 0 01-.16-2c.007-.67.06-1.338.16-2h4.68c.1.662.153 1.33.16 2-.008.67-.061 1.338-.16 2zm.25 5.56A15.649 15.649 0 0015.97 16h2.95a8.03 8.03 0 01-4.33 3.56zM16.36 14c.087-.663.134-1.331.14-2a16.515 16.515 0 00-.14-2h3.38a7.822 7.822 0 010 4h-3.38z"}})])
          )
        }
      }
    